<script>
    import R, {LOADER} from "../../lib/requests";
    import user from "../../stores/user";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import Icon from "../../components/Icon.svelte";
    import Alert from "../../stores/alerts";
    import {setFocusTo} from "../../lib/lib";

    export let clientId = null;
    export let client = null;
    export let excludeFromSelection = []; // client objects to exclude from selection
    export let allowCreate = true;
    export let css = '';
    export let id = 'clientName';
    export let placeholder = "εύρεση πελάτη";

    let name = client ? client.name : '';
    let results = [];
    let listIndex = -1;
    let excludeIds = [];
    let timer;
    let showDropdown = false;


    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onKeydown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter' && listIndex > -1) {
                event.preventDefault();
                selectResult(results[listIndex]);
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyup = (event) => {
        if (name !== event.target.value) {
            name = event.target.value;
            if (name) {
                if (timer) {
                    clearInterval(timer);
                }
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                if (client) {
                    clientId = null;
                    client = null;
                    dispatch('select', null);
                }
            }
        }
    }

    const onFocusOut = () => {
        setTimeout(() => {
            if (client === null) {
            name = '';
        }
        }, 100)
    }

    const selectResult = (item) => {
        name = item.name;
        clientId = item.id;
        client = item;
        dispatch('select', item);
        closeDropdown();
    }

    const search = () => {
        const onSuccess = result => {
            results = [];
            result.map(item => {
                if (excludeIds.indexOf(item.id) < 0) {
                    results.push(item);
                }
            });
            openDropdown();
        }

        const onFailure = err => {
        };

        R.handle(R.client.index, {name: name}, onSuccess, onFailure);
    }

    const openDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            results = [];
            listIndex = -1;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    const createFromName = () => {
        if (!name) {
            return;
        }

        const onSuccess = result => {
            selectResult(result);
        }

        const onFailure = err => {
            closeDropdown();
            Alert.warning("Project", err.message);
        };

        let newClient = {
            id: 0,
            name: name,
            owner_id: $user.id,
        }

        R.handle(R.client.create, newClient, onSuccess, onFailure, LOADER.POPUP);
    }


    if (client && !clientId) {
        clientId = client.id;
    }

    $: {
        if (excludeFromSelection) {
            if (excludeFromSelection.length != excludeIds.length) {
                excludeIds = excludeFromSelection.map(item => {
                    return item.id;
                });
            }
        } else {
            excludeIds = [];
        }

        // if bounded value of clientId has been reset
        // outside of control
        if (!clientId && client) {
            client = null;
            name = "";
        }
    }
</script>

<div class="select-control { css }" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="search">
        <input type="text" class="form-control" {id} value="{ name }"
               on:keydown="{ onKeydown }"
               on:keyup="{ onKeyup }"
               on:focusout={ onFocusOut }
               autocomplete="off"
               {placeholder}>
    </div>
    {#if showDropdown}
        <div class="control-dropdown">
            <ul>
                {#if results.length}
                    {#each results as item, index}
                        <li class="dropdown-item" class:active="{ listIndex === index }"
                            on:click="{ () => selectResult(item) }">
                            { item.name }
                        </li>
                    {/each}
                {/if}
                {#if allowCreate}
                    <li class="separator"></li>
                    <li>
                        <button class="btn btn-link" on:click="{ createFromName }"><Icon name="plus-circle"/> Καταχώρηση ως νέου</button>
                    </li>
                {/if}
            </ul>
        </div>
    {/if}
</div>

<style>
    .select-control {
        position: relative;
    }

    .select-control .control-dropdown {
        position: absolute;
        width: max-content;
        min-width: 200px;
        background: var(--dropdown-background);
        box-shadow: var(--dropdown-box-shadow);
        z-index: 5000;
    }

    .control-dropdown ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .control-dropdown ul > li.input-item {
        padding: 15px;
    }

    .control-dropdown ul > li.dropdown-item {
        cursor: pointer;
        padding: 10px 10px;
    }

    .control-dropdown ul > li.dropdown-item:hover,
    .control-dropdown ul > li.dropdown-item.active {
        background: var(--dropdown-item-hover-background);
    }

    .control-dropdown ul > li.separator {
        border-top: var(--dropdown-separator);
    }
</style>